export default class EceptionWithObject extends Error{
    constructor(message, object){
        super(message);
        this.object = object;
    }
}